import { useState, useEffect } from "react";
import "./ExystSpace3.css";
import Es3Hero from "./sections/Es3Hero";
import Es3Ticker from "./sections/Es3Ticker";
import Es3Story from "./sections/Es3Story";
import Es3Filmstrip from "./sections/Es3Filmstrip";
import Es3Room from "./sections/Es3Room";
import Es3Deal from "./sections/Es3Deal";
import Es3Manifesto from "./sections/Es3Manifesto";
import Es3Apply from "./sections/Es3Apply";
import Es3Footer from "./sections/Es3Footer";

function ExystSpace3() {
  const [scrolled, setScrolled] = useState(false);

  /* Override the global overflow/height from App.css so this page can scroll on iOS Safari */
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevHtmlHeight = html.style.height;
    const prevBodyOverflow = body.style.overflow;
    const prevBodyHeight = body.style.height;
    html.style.overflow = "auto";
    html.style.height = "auto";
    body.style.overflow = "auto";
    body.style.height = "auto";
    return () => {
      html.style.overflow = prevHtmlOverflow;
      html.style.height = prevHtmlHeight;
      body.style.overflow = prevBodyOverflow;
      body.style.height = prevBodyHeight;
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToApply = () => {
    document.getElementById("es3-apply")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="es3-wrap">
      <div className="es3-grain" aria-hidden="true" />
      <div className="es3-vignette" aria-hidden="true" />

      <nav className={`es3-nav${scrolled ? " scrolled" : ""}`}>
        <a className="es3-nav-logo" href="#es3-top">
          <img src="/image/exyst-space-logo.svg" alt="exyst space"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        </a>
        <span className="es3-nav-loc">DD Block, DHA Phase 4, Lahore</span>
        <button className="es3-nav-cta" onClick={scrollToApply}>Fill the form</button>
      </nav>

      <Es3Hero id="es3-top" />
      <Es3Ticker />
      <Es3Story />
      <Es3Filmstrip />
      <Es3Room />
      <Es3Manifesto />
      <Es3Deal />
      <Es3Apply />
      <Es3Footer />
    </div>
  );
}

export default ExystSpace3;
